// extracted by mini-css-extract-plugin
export default {"sensorCell":"dispatched-sensors-section-module__sensorCell--Oj_wF","rightDispatchButtons":"dispatched-sensors-section-module__rightDispatchButtons--xz0Tp"};